export default __webpack_public_path__ + "static/cobalt-sign_logo-a752d681843bdf68f0573d7eab732522.svg";